const State = cc.Enum({
    STATE_MAIN: 'main',
    STATE_DISABLED: 'disabled',
    STATE_AUTOPLAY: 'autoplay'
});

const Events = require('PSEvents');

cc.Class({
    extends: cc.Component,

    properties: {
        iconSprite: cc.Sprite,
        idleIcon: cc.SpriteFrame,
        autoplayIcon: cc.SpriteFrame,
        autoplaySpins: cc.Label,
        icon: cc.Node,
        infinitySign: cc.Node,
        activeNode: cc.Node,
    },

    onLoad () {
        this.widget = this.node.getComponent(cc.Widget);
        this.button = this.node.getComponent(cc.Button);
        this.icon.originScale = this.icon.scaleX;
    },

    start () {
        // this.enableButton();
    },

    setAutoplayState () {
        this.state = State.STATE_AUTOPLAY;
        this._setSkin(this.state);
        this.autoplaySpins.node.active = true;
    },

    updateSpinAmount (amount) {
        const isInfinite = amount === Number.MAX_SAFE_INTEGER;

        this.infinitySign.active = isInfinite;
        this.autoplaySpins.node.active = !isInfinite;

        this.spinAmount = amount;
        this.autoplaySpins.string = this.spinAmount;

        this._spinIcon(this.icon, 0.7);
    },

    _spinIcon (node, time, animEasing = cc.easeBackInOut(0.5)) {
        const s = node.originScale;

        node.stopAllActions();
        node.angle = 0;
        node.setScale(s,s);
        node.runAction(cc.spawn(
            cc.sequence(
                cc.scaleTo(time * 0.3, 1.1 * s, 1.1 * s).easing(cc.easeCircleActionOut()),
                cc.delayTime(time * 0.4),
                cc.scaleTo(time * 0.3, s, s).easing(cc.easeCircleActionIn())
            ),
            cc.rotateBy(time, 360).easing(animEasing)
        ));
    },

    _setSkin (skinState) {
        let newSkin;

        switch (skinState) {
            case State.STATE_MAIN:
            case State.STATE_DISABLED:
                newSkin = this.idleIcon;
                this.activeNode.active = false;
                if (this.iconSprite.spriteFrame !== newSkin) {
                    this._spinIcon(this.icon, 0.3, cc.easeBackOut(0.8));
                }
                this.iconSprite.spriteFrame = newSkin;
                break;
            case State.STATE_AUTOPLAY:
                newSkin = this.autoplayIcon;
                this.activeNode.active = true;
                this.iconSprite.spriteFrame = null;
                break;
        }
    },

    /**
     * Called on spin click or space/enter keydown. When it right state it will dispatch a spin
     * and show the according button animations.
     * @param skipAnimationOnSpin {Boolean=} if set to true button will skip spin animations and
     * just go directly to the appropriate state
     */
    onClick () {
        switch (this.state) {
            case State.STATE_MAIN:
            case State.STATE_DISABLED:
                this.openAutoplayMenu();
                break;
            case State.STATE_AUTOPLAY:
                this.stopAutoplay();
                break;
        }
        this._setSkin(this.state);
    },

    enableButton () {
        if (this.state === State.STATE_AUTOPLAY) {
            return;
        }
        this.button.node.opacity = 255;
        this.button.interactable = true;
        this.autoplaySpins.node.active = false;
        this.infinitySign.active = false;
        this.state = State.STATE_MAIN;
        this._setSkin(this.state);
    },

    /**
     * Set the state to disabled. The button changes its visual state,
     * whereas the hide function just changes only the this.isInteractable flag
     */
    disableButton () {
        if (this.state === State.STATE_DISABLED || this.state === State.STATE_AUTOPLAY) {
            return;
        }
        this._disable();  
    },

    _disable() {
        this.button.node.opacity = 100;
        this.button.interactable = false;
        this.autoplaySpins.node.active = false;
        this.infinitySign.active = false;
        this.state = State.STATE_DISABLED;
        this._setSkin(this.state);
    },

    /**
     * Hides autoplay counter, dispatches 'stopAutoplay' event,
     * changes the button state and plays the click sound.
     */
    stopAutoplay () {
        this._disable();

        const event = new cc.Event.EventCustom(Events.BUTTON_STOP_AUTOPLAY);

        this.node.dispatchEvent(event);
    },
    
    openAutoplayMenu () {
        const event = new cc.Event.EventCustom(Events.AUTOPLAY_OPEN);

        this.node.dispatchEvent(event);
    },

    show () {
        this.node.active = true;
    },

    hide () {
        this.node.active = false;
    }
});
